<template>
    <div class="box">
      <box-border
        title="安全工时"
        padding="0.4rem 0 0.2rem"
        :boxStyle="{
          'grid-row': '1 / span 1',
          'grid-column': '1 / span 5'
        }"
        :childBoxClass="['flexColumnAround']"
      >
        <span class="safeHoursTop">今天是 
          <span class="lineHeightfontClass" :key="`first${index}`" v-for="(item, index) in String(new Date().getFullYear())">{{ item }}</span>
          年
          <span class="lineHeightfontClass" :key="`second${index}`" v-for="(item, index) in String(nowMonth)">{{ item }}</span>
          月
          <span class="lineHeightfontClass" :key="`third${index}`" v-for="(item, index) in String(nowDate)">{{ item }}</span>
          日
        </span>
        <div class="safeCenter">
          <span class="projectSafe">项目安全运行<span>{{ safeHours.v2 }}</span>天</span>
          <span class="projectSafe">项目累计安全生产<span>{{ Number(safeHours.v3).toLocaleString() }}</span>工时</span>
          <template v-if="safeHours.v4 == 0 && safeHours.v5 == 0">
            <span class="projectSafe">无安全事故发生</span>
          </template>
        </div>
        <template v-if="safeHours.v4 > 0 || safeHours.v5 > 0">
          <span class="safeHourSpan">
            <span style="padding-right: 0.6rem;color: #2EC7C9;">{{ safeHours.v4 > 0 ? safeHours.v4 + '起' : '无' }}安全事故发生</span>
            <span style="color: #FDB901;">{{ safeHours.v5 > 0 ? safeHours.v5 + '起' : '无' }}安全事件发生</span>
          </span>
        </template>
      </box-border>
      <box-border
        title="项目大事记"
        padding="0.4rem 0.2rem 0.2rem"
        :boxStyle="{
          'grid-row': '1 / span 2',
          'grid-column': '6 / span 8'
        }"
        :childBoxClass="['flexColumn']"
      >
        <scroll-box
          :style="{
            height: '80%'
          }"
          :imgArr="HighImgArr"
          :promiseGetImg="promiseGetImg"
        ></scroll-box>
        <div class="flexColumn" style="height: 18%;">
          <div class="lineBorder"></div>
          <scroll-text
            :loadData="loadData"
            :boxStyle="{
              height: '85%',
              background: '#0B1547'
            }"
            :liStyle="{
              'font-size': '.14rem',
              'font-family': 'Microsoft YaHei',
              'font-weight': 400,
              'color': '#FFFFFF',
              'line-height': '.22rem',
              'padding-left': '0.23rem'
            }"
          >
            <template #default="{data}">
              <span v-show="data.v1"
                :style="{
                  'width': '.3rem',
                  'height': '.15rem',
                  'display': 'inline-block',
                  'background-image': new Date(data.v2) > new Date() - 1000 * 60 * 60 * 24 * 30 ? `url(${require('../assets/homeImage/icon-new.png')})` : '',
                  'background-size': '100% 100%',
                  'margin-right': '.15rem',
                  'vertical-align': 'middle'
                }"></span><span>{{data.v2}}&nbsp;{{data.v1}}</span>
            </template>
          </scroll-text>
          <div class="lineBorder"></div>
        </div>
      </box-border>
      <box-border
        title="数字化展板"
        padding="0.46rem 0 0.28rem"
        :boxStyle="{
          'grid-row': '1 / span 1',
          'grid-column': '14 / span 5'
        }"
        :childBoxStyle="{
          'font-size': '0.16rem',
          'display': 'grid',
          'grid-template-columns': 'repeat(2, 1fr)',
          'grid-row-gap': '0.1rem',
          'grid-template-rows': `repeat(${Math.ceil(leftBoxProgress.length / 2)}, 1fr)`
        }"
      >
        <div class="flexColumnAround" v-for="(item, index) in leftBoxProgress" :key="index">
          <a
            :class="['routerLink', {
              noPermission: !$store.state.userMenu.find(menu => menu.permission === item.permission)
            }]"
            @click="goLink(item)"
          >
            <img src="../assets/homeImage/icon-panel.png" style="height: 80%;margin-right: 0.14rem;" />
          {{item.name}}
        </a>
        </div>
      </box-border>
      <box-border
        title="项目文化"
        padding="7% 0.8rem 0.38rem 0.8rem"
        :childBoxClass="['flexColumn']"
        :boxStyle="{
          'grid-row': '2 / span 1',
          'grid-column': '1 / span 5'
        }"
      >
        <div class="projectCulture">
          <span></span>
          <span></span>
        </div>
        <div class="cultureCenter">
          <span>不为困难找理由{{ String('\u3000') }}只为成功想办法</span>
        </div>
        <div class="cultureCenter">
          <span>
            <span>重执行&#12288;敢担当&emsp;多包容</span>
            <br/>
            <span>常沟通{{ String.fromCharCode(12288) }}讲团结{{ String.fromCharCode(12288) }}正能量</span>
          </span>
        </div>
      </box-border>
      <box-border
        title="系统功能"
        padding="0.59rem 0 0.42rem 0"
        :boxStyle="{
          'grid-row': '2 / span 2',
          'grid-column': '14 / span 5'
        }"
      >
        <div class="sysFunction">
          <div v-for="(item, index) in sysFunctionData" @click="goPage(item)" :key="index">
            <span
              :style="{
                width: '.58rem',
                height: '.50rem',
                backgroundImage: getImage(item),
                backgroundSize: '100% 100%'
              }"
            ></span>
            <span :style="{
              color: item.href ? '' : '#517fb5'
            }">{{ item.name }}</span>
          </div>
        </div>
      </box-border>
      <box-border
        title="人员动态"
        :boxStyle="{
          'grid-row': '3 / span 1',
          'grid-column': '1 / span 5'
        }"
        padding="0.25rem 0.2rem 0.1rem 0.2rem"
        :childBoxClass="['flexColumn']"
      >
        <top-tab
          :topBarDatas="topBarDatas"
          :boxStyle="{
            'display': 'flex',
            'justify-content': 'center'
          }"
          :divStyle="{
            'height': '0.25rem',
            'margin-bottom': '0.1rem'
          }"
          :nameStyle="{
            'font-size': '0.14rem'
          }"
        ></top-tab>
        <echart-module
          :option="mobileData"
          ref="mobileData"
          style="height: 80%;contain: content;"
        ></echart-module>
      </box-border>
      <box-border
        title="项目总体进度"
        :boxStyle="{
          'grid-row': '3 / span 1',
          'grid-column': '6 / span 8'
        }"
      >
        <span style="font-size: 0.16rem;color: #fc0;position: absolute; top: -0.1rem; right: 0.20rem;">
          P: {{ projectProgress.otherObj.P }} A: {{ projectProgress.otherObj.A }} V: {{ projectProgress.otherObj.V }}
        </span>
        <echart-module
          ref="projectProgress"
          :option="projectProgress"
        ></echart-module>
      </box-border>
    </div>
</template>
<script>
import { mapActions } from 'vuex'
import { servedataUsingGET, findHomeImageConfigUsingPOST, getBulletinByDate3ModulenameUsingGET, servedetailUsingGET, downloadGetThumUsingGET } from '@/api/dataapi'
import { mapState } from 'vuex'
import storage from 'store'
export default {
  filters: {
    linkToFn(link){
      if(link.length){
        if(link.includes('http')){
          if(link.includes('?')){
            return `${link}&token=${storage.get('Access-Token')}`
          }else{
            return `${link}?token=${storage.get('Access-Token')}`
          }
        }else{
          return `${location.origin}${link}`
        }
      }
    }
  },
  name: 'Home',
  methods: {
    ...mapActions(['OPEN_TABLEBOX_DATAS']),
    goLink(item){
      const obj = this.$store.state.userMenu.find(menu => menu.permission === item.permission);
      if(obj){
        this.$router.push(item.href || '')
      }
    },
    goPage(item){
      if(item.href){
        if(item.href.includes('http')){
          if(item.href.includes('?')){
            return window.open(`${item.href}&token=${storage.get('Access-Token')}`)
          }else{
            return window.open(`${item.href}?token=${storage.get('Access-Token')}`)
          }
        }else{
          return window.open(`${location.origin}${item.href}`)
        }
      }
    },
    getImage(item){
      if(item.href){
        return `url(${require(`../assets/homeImage/${item.icon}.png`)})`
      }else{
        return `url(${require(`../assets/homeImage/${item.icon}_no.png`)})`
      }
    },
    promiseGetImg() {
      return findHomeImageConfigUsingPOST({
          modulename: this.modulename,
          hic: {},
          size: 99
        }).then(({ content }) => {
          // 获取本地图片
          const allImgs = content.filter(item => item.imagename?.includes('Home')).sort((second, first) => second.ordercode - first.ordercode);
          this.HighImgArr = new Array(allImgs.length).fill(require('../assets/homeImage/default.jpg'));
          const arr = allImgs.map((item) => {
            return downloadGetThumUsingGET({
              fileext: item.att.ext,
              id: item.att.id,
              modulename: item.modulename,
              thumb: false
            })
          });
          return Promise.allSettled(arr);
        }).then(result => {
          this.$nextTick(() => {
            result.forEach((item, index) => {
              if(item.status == 'fulfilled'){
                this.HighImgArr.splice(index, 1, item.value);
              }
            })
          })
        })
    },
    //人员动态
    getPersonState(id, tableId){
      this.AllowClickObj = {
        nowClick: '',
        AllowClick: true
      }
      this.getEchartsPie(
        id,
        '人数',
        this.$refs.mobileData.myChart,
        {
          name: 'mobileData',
          clickFn: async (params) => {
            if(this.AllowClickObj.nowClick != params.name || this.AllowClickObj.AllowClick){
              const data = await this.getTableData(tableId, params.name);
              this.OPEN_TABLEBOX_DATAS(data);
              this.AllowClickObj.nowClick = params.name;
              this.AllowClickObj.AllowClick = false;
            }else{
              this.AllowClickObj.AllowClick = !this.AllowClickObj.AllowClick;
            }
          }
        }
      )
    }
  },
  mounted(){
    setTimeout(async () => {
      this.$refs.mobileData.myChart.resize();
      //获取人员总数
      const result = await Promise.all([
        servedataUsingGET({chartid: '2c92808f824759e401827b662c930081'}),
        servedataUsingGET({chartid: '2c92808783c55c810183ed8f9b0b0179'})
      ]);
      this.topBarDatas = [
        {
          name: `联合体( ${result[0].s1.reduce((total, next) => +total + +next)}人 )`,
          fn: () => {
            this.getPersonState('2c92808f824759e401827b662c930081', '2c92808f824759e401827b6771090082');
          }
        },
        {
          name: `分包商( ${result[1].s1.reduce((total, next) => +total + +next)}人 )`,
          fn: () => {
            this.getPersonState('2c92808783c55c810183ed8f9b0b0179', '2c92808783c55c810183ed91eae6017a');
          }
        }
      ];
    }, 50)
    const getXhrArr = [
      //系统功能
      async () => {
        fetch(`${process.env.NODE_ENV === 'production' ? '/uganda/general/' : '/'}json/setting.json?timer=${+new Date()}`).then(res => {
          return res.json();
        }).then(res => {
          this.sysFunctionData = res.sysFunctionData;
        })
      },
      //安全工时
      async () => {
        const res = await servedetailUsingGET({
          chartid: '2c92808f824759e40182581dea290018',
          dataindex: 0,
          stype: 0
        })
        this.safeHours = res.sort((a,b) => {
          return b.v1 - a.v1;
        })[0] || {};
      },
      //项目总体进度
      async () => {
        this.getNewVTos(
          {
            id: '2c92808f824759e401825c3698c20054',
            stype: 'Project'
          },
          [
            ['累计计划', '累计实际', '累计预测'],
            ['line', 'line', 'line'],
          ],
          this.$refs.projectProgress.myChart,
          {
            name: 'projectProgress',
            hasMoreData: ['s7'],
            startIndex: 2,
            moreSetting: [
              {},
              {},
              {
                lineStyle: {
                  type: 'dashed'
                }
              },
            ]
          },
          (res) => {
              this.$nextTick(() => {
                  this.$refs.projectProgress.myChart.dispatchAction({
                      type: 'showTip',
                      seriesIndex: 0,
                      dataIndex: res.s3.findLastIndex(item => item !== ' ')
                  });
                  const dataIndex = res.s3.findLastIndex(item => item !== ' ');
                  this.$set(this.projectProgress.otherObj, 'P', res.s2[dataIndex]);
                  this.$set(this.projectProgress.otherObj, 'A', res.s3[dataIndex]);
                  this.$set(this.projectProgress.otherObj, 'V', res.s7[dataIndex]);
              })
          }
        );
      }
    ];
    this.getAllPromise(getXhrArr);
  },
  computed: {
    ...mapState(['modulename']),
    nowMonth: {
      get(){
        return new Date().getMonth() > 8 ? new Date().getMonth() + 1 : `0${new Date().getMonth() + 1}`
      }
    },
    nowDate: {
      get(){
        return new Date().getDate() > 9 ? new Date().getDate() : `0${new Date().getDate()}`
      }
    },
  },
  data () {
    return {
      topBarDatas: [],
      //系统功能
      sysFunctionData: [],
      //人员动态
      AllowClickObj: {
        nowClick: '',
        AllowClick: true
      },
      mobileData: {
        grid: {
          top: "15%",
          bottom: '15%'
        },
        color: [0,1,2,3,4]
      },
      //项目总体进度
      projectProgress: {
        otherObj: {
          P: '',
          A: '',
          V: ''
        },
        color: [1, 0, 0],
        grid: {
          top: '10%',
          bottom: this.fontSizeFn(60),
          right: '2%'
        },
        tooltip: {
          formatter: function(datas){
            let html = `${datas[0].axisValue} <br />`;
            datas.forEach(item => {
                if(item.value){
                    html += (item.marker + item.seriesName + '&nbsp;&nbsp;' + item.value + '<br/>')
                }
            })
            datas[0].data.s7.replaceAll(/\s/g, '') && (html += `<span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:#FFFFFF;"></span>累计偏差&nbsp;&nbsp;${datas[0].data.s7}<br/>`)
            return html;
          }
        },
        dataZoom: [
          {
            height: this.fontSizeFn(20),
            moveHandleSize: 0,
            bottom: this.fontSizeFn(20) + 10,
            textStyle: {
                color: '#8392A5'
            },
            dataBackground: {
              areaStyle: {
                  color: '#8392A5'
              },
              lineStyle: {
                  opacity: 0.8,
                  color: '#8392A5'
              }
            },
            brushSelect: true
          }, {
            type: 'inside',
            filterMode: 'filter'
          }
        ],
      },
      //安全工时
      safeHours: {},
      //通知公告
      loadDataNotice: getBulletinByDate3ModulenameUsingGET({ modulename: this.$store.state.modulename }).then(res => {
        return res.data;
      }),
      //图片
      HighImgArr: [],
      loadData: servedetailUsingGET({ chartid: '2c92808f824759e40182581f8f5f0019', dataindex: 0, stype: 0 }),
      leftBoxProgress: [
        {
          name: '计划管理',
          href: '/planManage',
          permission: 'Uganda_Portal_Schedule'
        },
        {
          name: '设计管理',
          href: '/engineering',
          permission: 'Uganda_Portal_Engineering'
        },
        {
          name: '采办管理',
          href: '/purchase',
          permission: 'Uganda_Portal_Purchase'
        },
        {
          name: '现金流管理',
          href: '/Cost',
          permission: 'Uganda_Portal_Cost'
        },
        {
          name: '物流仓储管理',
          href: '/logistics',
          permission: 'Uganda_Portal_Logistics'
        },
        {
          name: '文档管理与督办',
          href: '/document',
          permission: 'Uganda_Portal_Document'
        },
        {
          name: '本地化管理',
          href: '/localization',
          permission: 'Uganda_Protal_Localization'
        },
        {
          name: 'QHSE管理',
          href: '/QHSE',
          permission: 'Uganda_Portal_QHSE'
        }
      ],
    }
  },
}
</script>
<style scoped lang="less">
  .sysFunction{
    .gridStyle(3, 4, 0, 0);
    height: 100%;
    font-size: .16rem;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FFFFFF;
    line-height: .20rem;
    div{
      cursor: pointer;
      &:hover{
        color: #02D9FD;
      }
      margin: 0 auto;
      span{
        display: block;
        margin: 0 auto;
        &:last-child{
          margin-top: .13rem;
        }
      }
    }
  }
  .cultureCenter{
    width: 100%;
    text-align-last: justify;
    display: flex;
    text-align: justify;
    justify-content: center;
    font-size: .21rem;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #2EC7C9;
    span{
      width: 100%;
    }
    &:last-child{
      color: #FDB901;
    }
  }
  .projectCulture{
    align-self: center;
    width: 100%;
    display: flex;
    justify-content: space-between;
    span{
      width: 1.41rem;
      height: .34rem;
    }
    span:first-child{
      background-image: url('../assets/homeImage/HYprojec.png');
      background-size: 100% 100%;
    }
    span:last-child{
      margin-left: .37rem;
      background-image: url('../assets/homeImage/ZYproject.png');
      background-size: 100% 100%;
    }
  }
  .newBgc{
    width: .3rem;
    height: .15rem;
    display: inline-block;
    background-image: url('../assets/homeImage/icon-new.png');
    background-size: 100% 100%;
    margin-right: .15rem;
    vertical-align: middle;
  }
  .safeCenter{
    min-height: 0.81rem;
    .flexColumn();
  }
  .safeHoursTop{
    font-size: 0.14rem;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FFFFFF;
    .lineHeightfontClass{
      &:first-child{
        margin-left: 0.13rem;
      }
      &:nth-child(4),&:nth-child(6),&:nth-child(8){
        margin-right: .07rem;
      }
      &:nth-child(5),&:nth-child(7){
        margin-left: .07rem;
      }
      width: .29rem;
      height: .34rem;
      line-height: .34rem;
      text-align: center;
      background-image: url('../assets/homeImage/dataBgc.png');
      background-size: 100% 100%;
      font-size: .20rem;
      color: #02D9FD;
    }
  }
  .projectSafe{
    font-size: 0.14rem;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #02D9FD;
    span{
      color: #fff;
      font-size: .3rem;
    }
    &:first-child::before{
      content: '';
      display: inline-block;
      width: .22rem;
      height: .26rem;
      margin-right: 0.22rem;
      background-image: url('../assets/homeImage/safeFunction.png');
      background-size: 100% 100%;
      vertical-align: middle;
    }
    &:nth-child(3){
      margin-top: 0.15rem;
    }
    &:last-child::before, &:nth-child(2)::before{
      content: '';
      vertical-align: middle;
      display: inline-block;
      width: .22rem;
      height: .26rem;
      margin-right: 0.22rem;
      background-image: url('../assets/homeImage/cumulative.png');
      background-size: 100% 100%;
    }
  }
  .box{
    padding-top: 0.24rem;
    height: 100%;
    box-sizing: border-box;
    contain: layout;
    .gridStyle(18, 3, 0.45rem, 0.25rem);
    font-size: 0.18rem;
    color: #fff;
  }
  .safeHourSpan{
    font-size: .20rem;
    font-family: Microsoft YaHei;
    font-weight: 400;
    .flexAround();
  }
  .routerLink{
    display: flex;
    align-items: center;
    padding-left: 0.16rem;
    color: #ffffff;
    text-decoration: none;
    border: 1px solid #1A3F81;
    border-radius: 0.1rem;
    width: 1.96rem;
    text-align: center;
    height: 100%;
    cursor: pointer;
    max-height: 0.44rem;
    // height: 0.44rem;
    // padding: 0.1rem 0;
    font-size: 0.16rem;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #02D9FD;
    &:hover{
        background: #00A1E9;
    }
  }
  .rightLink{
    a{
      width: 1.2rem;
    }
  }
  .noPermission{
    color: #517fb5;
    cursor: default;
    &:hover{
      background: rgba(0,0,0,0);
    }
  }
</style>
